// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const pattern = {
  angle: '',
  discrimination: '',
}

export const patternSet = (
  Array(15).fill().map(() => ({ ...pattern }))
)

export const initialValues = {
  antennaApplicationId: '1', // NOTE - antennaApplicationId is hard coded here
  antennaPatternId: null,
  antennaSpecId: null,
  associatedAntennaSpec: '',
  beamwidth: '',
  classificationId: '',
  classification: '',
  complianceId: '',
  company: '',
  createInfo: {},
  diameter: '',
  fbRatio: '',
  feedDirId: '',
  feedFlangeDiameter: '',
  beamwidth15db: '-',
  gain: '',
  hiFrequency: '',
  lastModifiedInfo: {},
  loFrequency: '',
  modifiedAntennaSpec: '',
  modelNumber: '',
  patterns: {},
  patternsSetDisplayed: '',
  singlePolarizationId: '',
  rpeDate: '',
  rpeNumber: '',
  statusId: '1', // NOTE - statusId is hard coded here
  subreflectorDiameter: '',
}
